// Thin async wrapper over the pure builders in cbsQueries.js. Does the actual
// network I/O (keyless CBS StatLine OData, CORS-enabled) and is intentionally
// not unit-tested — the testable logic lives in cbsQueries.js.
//
// AI-CONTEXT: See docs/features/adress-external-data.md

import { buildKerncijfersUrl, parseKerncijfersResponse } from './cbsQueries'

const fetchKerncijfers = async (buurtCode, signal) => {
    if (!buurtCode) return null
    const res = await fetch(buildKerncijfersUrl(buurtCode), signal ? { signal } : undefined)
    if (!res.ok) throw new Error(`CBS responded ${res.status}`)
    return parseKerncijfersResponse(await res.json())
}

export { fetchKerncijfers }
